$shm_hitalama_vk_token_switch $mol_view
	tokens /$shm_hitalama_vk_token
	current null $shm_hitalama_vk_token
	sub /
		- ^ tokens_view /
		<= Switch $mol_switch
			value? <=> current_link? \
			keys <= tokens_links /string
			option_label* <= option_label* /
				<= Token* $shm_hitalama_vk_token_view
					token <= token* $shm_hitalama_vk_token
		<= Add $mol_pop_over
			Anchor <= Add_anchor $mol_button_minor title \Добавить
			bubble_content /
				<= Add_vk $mol_link
					title \VK
					target \_self
					uri <= vk_auth_uri \
		<= Clear $mol_button_minor
			title \Очистить
			click? <=> clear? null
	auto /
		<= vk_token_url_parse \
	vk_client_id \7803698
	vk_redirect_uri \http://localhost:9080/shm/hitalama/app/-/test.html
